import React from 'react'
import NumpadInputButton from 'redesign/components/atoms/Buttons/numpad-buttons/numpad-input-button'
import { EraseIcon } from 'redesign/components/atoms/Icon'
import { NUMBERS, NUMPAD_ARIA_LABEL, NUMPAD_TEST_ID, ZERO_KEY } from './constants'
import { Container, NumpadRow } from './styles'
import type { NumpadProps } from './types'
import { useNumpad } from './use-numpad'

const Numpad: React.FC<NumpadProps> = (props) => {
  const { handleInputClick, handleDeleteClick, renderBottomLeftButton } = useNumpad(props)

  return (
    <Container>
      {NUMBERS.map((row, i) => (
        <NumpadRow key={`row_${i.toString()}`}>
          {row.map((numberKey) => (
            <NumpadInputButton
              ariaLabel={NUMPAD_ARIA_LABEL}
              testId={NUMPAD_TEST_ID}
              key={numberKey}
              input={numberKey}
              onClick={() => handleInputClick(numberKey)}
            />
          ))}
        </NumpadRow>
      ))}

      <NumpadRow>
        {renderBottomLeftButton()}
        <NumpadInputButton
          ariaLabel={NUMPAD_ARIA_LABEL}
          testId={NUMPAD_TEST_ID}
          input={ZERO_KEY}
          onClick={() => handleInputClick(ZERO_KEY)}
        />
        <NumpadInputButton
          ariaLabel="Numpad delete"
          testId="numpad-delete"
          icon={<EraseIcon />}
          onClick={handleDeleteClick}
        />
      </NumpadRow>
    </Container>
  )
}

export default Numpad
